import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth'

const firebaseConfig = {
    apiKey: "AIzaSyDJbYjKVPJortMEHOGrIAziK_PrWmdPENM",
    authDomain: "netflixclone-b06d8.firebaseapp.com",
    projectId: "netflixclone-b06d8",
    storageBucket: "netflixclone-b06d8.appspot.com",
    messagingSenderId: "926247857058",
    appId: "1:926247857058:web:170b6065c3e013b88820fb",
    measurementId: "G-DJE5FZC4E8"
  };

const app = initializeApp(firebaseConfig)

export const authetication = getAuth(app)